<template>
  <div class="teammates-wrap content">
    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">


        <div class="row">

          <div class="col-sm-6 mb-sm"><h1 class="h1">Your Teammates</h1></div>
          <div class="col-sm-6 mb-sm text-right">
            <a href="#" v-on:click.prevent="inviteAdminModal = true" class="btn btn-fa-plus">
              <font-awesome-icon :icon="['fas', 'plus']"/>Invite Teammate
            </a>
          </div>


          <div class="col-sm-12">
            <div v-if="teammates" class="s-block">
              <div class="s-block-body d-block">
                <div class="contacts-list">
                  <table class="table">
                    <thead class="table-header">
                    <tr>
                      <th width="19%">Name</th>
                      <th width="24%">Email Address</th>
                      <th>Role</th>
                      <th width="137px">Status</th>
                      <th class="text-right" width="110px">Actions</th>
                    </tr>
                    </thead>
                    <tbody v-if="teammates.length">

                    <tr v-for="(teammate, index) in teammates"
                        :key="index">
                      <td>
                        {{teammate.firstName}} {{teammate.lastName}}
                        <div class="info"></div>
                      </td>
                      <td>
                        {{teammate.email}}
                        <div class="info">Email Address</div>
                      </td>
                      <td>
                        <span class="info">Administrator</span>
                        <div class="info">Role</div>
                      </td>
                      <td>
                        <span v-if="teammate.invite === 'pending'" class="txt-orange">Pending</span>
                        <span v-else class="txt-blue">Active</span>
                        <div class="info">Status</div>
                      </td>
                      <td class="text-right">
                        <a v-on:click.prevent="showRemoveAdminModal(teammate)"
                           href="#"
                        ><font-awesome-icon :icon="['far', 'times-circle']"/><i class="far fa-times-circle"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <modal v-if="inviteAdminModal"
           v-on:close-modal="inviteAdminModal = false"
           v-on:ok-modal="inviteAdminModal = false; inviteAdminSentModal = true"
           :modal-name="'admin-invites'"></modal>

    <modal v-if="inviteAdminSentModal"
           v-on:close-modal="inviteAdminSentModal = false"
           v-on:ok-modal="inviteAdminSentModal = false;"
           :modal-name="'invites-admin-sent'"></modal>

    <modal v-if="removeAdminModal"
           v-on:close-modal="removeAdminModal = false; activeTeammate = null"
           v-on:ok-modal="removeAdminModal = false; removeAdmin(activeTeammate.id); activeTeammate = null"
           :modal-name="'admin-remove'">
      <div slot="body" class="desc" v-if="activeTeammate">
        Are you sure you want to remove <b>{{activeTeammate.firstName}} {{activeTeammate.lastName}}</b>
        as an Administrator?
      </div>
    </modal>

  </div>
</template>

<script>
  import {getTeammates, removeTeammate} from '@/utils/api';
  import Modal from '../Modal/index.vue';
  import SettingsMenu from './menu.vue';
  import {mapState} from "vuex";

  export default {
    name: 'Teammates',
    metaInfo: {
      title: 'Settings - Teammates',
    },
    mounted() {
      this.loadTeammates();
    },
    components: {
      SettingsMenu,
      Modal,
    },
    methods: {
      loadTeammates() {
        getTeammates(this.activeCharityId).then(teammates => {
          this.teammates = teammates.members;
        });
      },
      removeAdmin(id) {
        id = parseInt(id);
        if (id) {
          removeTeammate(id, this.activeCharityId).then(() => {
            this.teammates = this.teammates.filter(teammate => parseInt(teammate.id) !== id);
          });
        }
      },
      showRemoveAdminModal(teammate) {
        this.removeAdminModal = true;
        this.activeTeammate = teammate;
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.teammates = null;
        this.activeTeammate = null;

        this.loadTeammates();
      },
    },
    data() {
      return {
        removeAdminModal: false,
        inviteAdminModal: false,
        inviteAdminSentModal: false,
        teammates: null,
        activeTeammate: null,
      };
    },
  };
</script>
<style lang="sass" scoped>
  .teammates-wrap
    .table
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2)
      border-radius: 4px
      overflow: hidden
      td
        padding: 16px 30px
      td:first-of-type
        text-align: left
      .fa-times-circle
        color: #ef3e42
        margin-left: 8px
      .svg-inline--fa
        font-size: 16px
      .info
        min-height: 15px
    span.info
      font-weight: 600
</style>
